module.exports = __webpack_public_path__ + "static/media/fow.0441349e.frag";